module.exports = __webpack_public_path__ + "static/img/bus-icon-2.ee1eb72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-icon-2.png
// module id = eVkr
// module chunks = 0